export default __webpack_public_path__ + "fonts/tpl_8.5c1b6815faf179676e4f0beb6a80a6bc.png";